export type PostCallVariableMappingEntry = {
  position: number
  source_type: 'variable'
  source_key: string
  fallback_text?: string
}

type LegacyPostCallMappingEntry = {
  position: number
  variable_key?: string
  source_type?: string
  source_key?: string
  fallback_text?: string
}

export function normalizePostCallMappingFromApi(
  mapping: LegacyPostCallMappingEntry[] | undefined,
): PostCallVariableMappingEntry[] {
  return (mapping ?? []).map((entry) => {
    const sourceKey = entry.source_key || entry.variable_key || ''
    return {
      position: entry.position,
      source_type: 'variable',
      source_key: sourceKey,
      ...(entry.fallback_text ? { fallback_text: entry.fallback_text } : {}),
    }
  })
}

export function buildPostCallVariableMapping(
  count: number,
  previous: PostCallVariableMappingEntry[] = [],
): PostCallVariableMappingEntry[] {
  return Array.from({ length: count }, (_, index) => {
    const position = index + 1
    const existing = previous.find((item) => item.position === position)
    if (existing) {
      return { ...existing, position, source_type: 'variable' }
    }
    return { position, source_type: 'variable', source_key: '' }
  })
}

export function normalizePostCallMappingForApi(
  mapping: PostCallVariableMappingEntry[],
): PostCallVariableMappingEntry[] {
  return mapping
    .filter((entry) => entry.source_key)
    .map((entry) => ({
      position: entry.position,
      source_type: 'variable' as const,
      source_key: entry.source_key,
      ...(entry.fallback_text ? { fallback_text: entry.fallback_text } : {}),
    }))
}
